<template lang="pug">
.videoDetails
  v-container
      v-row
        v-col(cols="12")
          v-btn(text dark @click="$router.go(-1)")
            v-icon(small left) fas fa-chevron-left
            span() {{$t('general.back')}}
        
        v-col(cols="12", md="7")
          v-row
            v-col(cols="12", v-if="!video")
              v-skeleton-loader.card.mx-auto.rounded-lg(type="image")
            v-col(cols="12", v-if="video")
              .player(v-if="!error && isProcessed")
                video-player#videoPlayer(
                  ref="videoPlayer",
                  :options="playerOptions",
                  @error="error = true",
                  :playsinline="true",
                  @ready="playerReadied",
                  
                )
              v-card.rounded-lg(color="primary" v-else)
                v-responsive(:aspect-ratio="16/9")
                  v-row.play-overlay.fill-height.ma-0(align='center' justify='center')
                    VideoStatusIcons.ml-2(:video="video")
              //- Card display content
        v-col(v-if="!video" cols="12", md="5")
          v-skeleton-loader.rounded-lg.mx-auto(type="article, table-heading")
        v-col(v-if="video" cols="12", md="5")
              v-card.rounded-lg(flat, v-if="!editContent" style="height: auto; position: relative;")
               
                v-card-title.primary--text.mr-8(primary-title) {{ video.title }}
                v-card-subtitle.blue-grey--text.lighten-2.caption {{ formatDate(video.createdAt) }}

                .moreMenu
                  VideoEditDeleteDialog
                v-card-text
                  v-chip.mb-4.mr-2(label small color="accent" v-for="(category, index) in video.categories.items" :key="index") {{ category.category.title }}                
                  div {{ video.description }}
                  

                v-card-actions.px-4(v-if="video.status === VideoStatus.COMPLETED" )
                  VideoDownloadButton(:video="video")
                  ShareMotionDialog(:video="video" v-if="hasFeatureAccess(RestrictedFeature.SOCIAL_CONNECTION_YOUTUBE)")
                  //- v-btn(@click="uploadToYouTube")
                  //-   | Upload to YouTube
      v-row.mt-8(v-if="video.element === VideoElement.MOTION")
        v-col(cols="12" md="8")
          ShareVideoLink
        v-col(cols="12" md="4")
          PodcastCard(:audioSrc="audioSrc")
        

        
        
      SharedToSocialCard( v-if="video && video.element === VideoElement.MOTION && hasFeatureAccess(RestrictedFeature.SOCIAL_CONNECTION_YOUTUBE)" :video="video")
</template>

<script>
import { mapGetters, mapState } from "vuex";
import date from "@/utils/date";
import urlFormat from "@/utils/urlFormat";
import { nameRules, descriptionRules } from "@/utils/validations";
import { VideoStatus, VideoElement, RestrictedFeature } from "../../models";
import SharedToSocialCard from "@/components/social/SharedToSocialCard";
import ShareMotionDialog from "@/components/video/ShareMotionDialog";
import VideoStatusIcons from "@/components/video/VideoStatusIcons";
import VideoDownloadButton from "@/components/video/VideoDownloadButton";
import ShareVideoLink from "@/components/video/ShareVideoLink";
import VideoAddToMotionCreator from "@/components/video/VideoAddToMotionCreator";
import VideoEditDeleteDialog from "@/components/video/VideoEditDeleteDialog";
import PodcastCard from "@/components/video/PodcastCard";
import VueVideoPlayer from "vue-video-player";
import { event } from "vue-analytics";
import { hasFeatureAccess } from "@/utils/featureAccess";

export default {
  name: "VideoDetails",
  components: {
    VideoStatusIcons,
    VideoDownloadButton,
    ShareVideoLink,
    VideoAddToMotionCreator,
    ShareMotionDialog,
    SharedToSocialCard,
    VideoEditDeleteDialog,
    PodcastCard,
  },
  data() {
    return {
      error: false,
      deleteDialog: false,
      loading: false,
      valid: true,
      editContent: false,
      nameRules,
      descriptionRules,
      VideoStatus,
      VideoElement,
      RestrictedFeature,
      audioSrc: "",
      playerOptions: {
        fluid: true,
        autoplay: false,
        loop: false,
        controls: true,
        language: "de",
        html5: {
          nativeAudioTracks: false,
          nativeVideoTracks: false,
          hls: {
            overrideNative: true,
          },
        },
        hls: {
          overrideNative: true,
        },
        sources: [
          {
            src: undefined,
            type: "application/x-mpegURL",
          },
        ],
      },
    };
  },

  computed: {
    publicUrlEnabled() {
      return !!this.video.publicToken;
    },
    isProcessed() {
      return this.video.status == VideoStatus.COMPLETED;
    },
    ...mapGetters("videoAsset", {
      video: "selectedVideoAsset",
    }),
    ...mapState({
      allCategories: (state) => state.settings.categories,
    }),
  },

  async mounted() {
    const id = this.$route.params.videoId;

    await this.$store.dispatch("videoAsset/FETCH_VIDEO_ASSET_BY_ID", id);

    const source = VueVideoPlayer.videojs.browser.IS_ANY_SAFARI
      ? {
          src: this.getVideoDownloadUrl(
            this.video.id,
            this.video.token,
            "_16x9_1920x1080p_24Hz_6Mbps",
            "mp4"
          ),

          type: "video/mp4",
        }
      : {
          src: this.getVideoStreamUrl(this.video.id, this.video.token),
          type: "application/x-mpegURL",
        };
    (this.playerOptions.poster = this.getThumbnailUrl(
      this.video.id,
      this.video.token,
      this.video.element
    )),
      (this.playerOptions.sources = [source]);
    this.audioSrc = this.getVideoDownloadUrl(
      this.video.id,
      this.video.token,
      "_16x9_1920x1080p_24Hz_6Mbps",
      "mp4"
    );
    await this.$store.dispatch("settings/FETCH_CATEGORIES");
    // this.loading = false;
  },
  beforeRouteLeave(_to, _from, next) {
    next();
    this.$store.commit("videoAsset/set_selected_video_asset_id", null);
  },

  methods: {
    hasFeatureAccess,
    ...date,
    ...urlFormat,
    copyPublicUrl() {
      const publicUrl = `${window.location.origin}/shared/${this.video.publicToken}`;
      navigator.clipboard.writeText(publicUrl);
    },
    async publicLinkSettingChanged(enabled) {
      if (enabled) {
        return this.$store.dispatch("motions/ENABLE_PUBLIC_URL", this.video.id);
      } else {
        return this.$store.dispatch(
          "motions/DISABLE_PUBLIC_URL",
          this.video.id
        );
      }
    },
    displayThumbnail(item) {
      const src = this.getThumbnailUrl(item.id, item.token, item.element);
      return src;
    },
    submit() {
      const data = {
        ...this.video,
        description: this.video.description ?? "",
        categoryIDs: this.video.categoryIDs ?? [],
      };

      this.loading = true;
      this.$store.dispatch("videoAsset/UPDATE_VIDEO_ASSET", data).then(() => {
        this.editContent = false;
        this.loading = false;
      });
    },
    deleteVideo({ id, element }) {
      this.$store
        .dispatch("videoAsset/DELETE_VIDEO_ASSET", { id, element })
        .then(() => {
          this.dialog = true;
          this.$router.go(-1);
        })
        .catch((e) => {
          console.log(e);
          this.dialog = true;
          this.$router.go(-1);
        });
    },
    playerReadied(player) {
      const token = this.video.token;
      event(this.video.element.toLowerCase(), "play");
      // var hls = player.tech({ IWillNotUseThisInPlugins: true }).hls;
      if (!player.tech_.hls.xhr) return;
      player.tech_.hls.xhr.beforeRequest = function (options) {
        options.uri = `${options.uri}${token}`;
        return options;
      };
    },
    getJsonElements(jsonString) {
      const jsonElements = JSON.parse(jsonString);
      if (jsonElements.elements.length > 0) {
        return jsonElements.elements.filter((item) => {
          console.log(item);
          return item.id !== "intro" && item.id !== "outro";
        });
      }
      return [];
    },
  },
};
</script>
<style lang="sass" scoped>

.play-overlay
    background: rgba(0,0,0,0.2)
    transition: all 0.3s ease
    cursor: pointer
    opacity: 1
    height: 100%
    width: 100%

.moreMenu
    position: absolute !important
    top: 18px !important
    right: 18px !important
</style>
